<template>
  <aside class="tm-diag-point" :style="styleObj">
    <i class="v" />
    <i class="h" />
  </aside>
</template>

<script>
export default {
  name: 'tm-diag-point',
  props: {
    point: { type: Object, required: true },
  },

  computed: {
    styleObj() {
      return {
        top: `${this.point.y}px`,
        left: `${this.point.x}px`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.tm-diag-point {
  position: absolute;
  transform: translate3d(-50%, -50%, 0) rotate(-45deg);
  width: 16px;
  height: 16px;
  z-index: var(--tm-zDiagPoint);
  pointer-events: none;

  &:before {
    color: #00aaf5;
    position: absolute;
    transform: translate(20px, 0);
    content: attr(data-label) '';
  }

  &:after {
    color: #0fe2b8;
    position: absolute;
    transform: translate(20px, 16px);
    content: attr(data-xy) '';
  }

  > .h {
    width: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border-top: 1px solid blueviolet;
  }
  > .v {
    position: absolute;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-left: 1px solid blueviolet;
  }
}
</style>
